<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div
      class="search-form btn-2b5a95"
    >
    <div class="l-w" :style="{
        height: $store.state.global.isSearchExtend_1
          ? ''
          : $store.state.global.searchFormHeight_1 + 10 + 'px',
      }">
      <el-form
        label-position="right"
        :class="$store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'"
				:model="searchForm"
				@submit.native.prevent
      >
				<el-form-item label="流水号:">
					<el-input
						v-model.trim="searchForm.id" 
						@keyup.enter.native="seach"
						clearable />
				</el-form-item>
        <el-form-item label="现金账户名称:">
          <el-input 
						v-model.trim="searchForm.accountname" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="审核状态:">
          <el-select 
						v-model="searchForm.approvestate" 
						@keyup.enter.native="seach"
						@visible-change="visibleType"
						ref="selectref"
						clearable>
            <el-option value="-2" label="未提起审批" />
            <el-option value="-1" label="审核中" />
            <el-option value="0" label="审核不通过" />
            <el-option value="1" label="通过" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属教学点:">
          <el-input 
						v-model.trim="searchForm.schoolorgname" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
      </el-form>
      </div>
      <div class="r-w">

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="seach"
        :loading="!$store.state.global.isEndRequest"
        class="btn-2b5a95"
        >搜索</el-button
      >
			<el-button type="primary" @click="resetQuery">重置</el-button>
      <el-button
        type="primary"
        :icon="
          $store.state.global.isSearchExtend_1
            ? 'el-icon-arrow-up'
            : 'el-icon-arrow-down'
        "
        v-if="$store.state.global.searchExtend_1"
        class="btn-2b5a95"
        @click="onExtendClick('isSearchExtend_1')"
        >{{ $store.state.global.searchExtendText_1 }}</el-button
      >
      </div>

    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      border
			stripe
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
			<el-table-column label="流水号" prop="id"></el-table-column>
      <el-table-column label="现金帐户名称" prop="accountname" align="center" width="180">
				<template slot-scope="scope">
          <el-button @click="btnShowDetail(scope.row)" type="text">{{
            scope.row.accountname
          }}</el-button>
        </template>
        </el-table-column>

      <el-table-column label="初始现金" prop="initmoney" align="center" />
      <el-table-column label="当前现金" prop="curmoney" align="center" />
      <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          {{ approvestateVal[scope.row.approvestate] }}
        </template>
      </el-table-column>
      <el-table-column label="所属教学点" prop="schoolorgname" align="center" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!--添加，修改-->
    <el-dialog
      class="btn-2b5a95"
      width="34%"
			:close-on-click-modal='false'
      :title="dialogTitle"
      :visible.sync="showAddModal"
      v-if="showAddModal"
			v-dialogDrag
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="20%"
        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
      >

        <el-form-item prop="companyorgname" label="所属分公司">
          <el-select
            v-model="dynamicValidateForm.companyorgname"
            placeholder="请选择"
            :disabled="!$store.state.login.isMaxAuth"
            clearable
            @change="onChangeCompany($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.companyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="schoolorgname" label="所属教学点">
          <el-select
            v-model="dynamicValidateForm.schoolorgname"
            placeholder="请选择"
            clearable
            @change="onChangeSchool($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.schoolList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="accountname" label="账户名称:">
          <el-input v-model.trim="dynamicValidateForm.accountname" clearable/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 查看审批 -->
    <el-dialog
      class="btn-2b5a95"
      title="审批记录："
			width="60%"
			:close-on-click-modal='false'
      :visible.sync="showModal"
			v-if="showModal"
			v-dialogDrag
      append-to-body
    >
      <el-table 
				:data="showTable.list" 
				style="width: 100%"
				border
				stripe
				:header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
				>
        <el-table-column label="流水号" prop="id" align="center" />
        <el-table-column label="员工名称" prop="objectname" align="center" />
        <el-table-column label="审核是否通过标志" align="center">
          <template slot-scope="scope">{{
            passflag[scope.row.passflag]
          }}</template>
        </el-table-column>
        <el-table-column label="审批意见" prop="approvedesc" align="center" />
        <el-table-column label="审批时间" align="center" width="200">
          <template slot-scope="scope">
            {{ scope.row.approvetime | formatDate("YYYY-MM-DD HH:MM:SS") }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>

    <!-- 会计审批表单 -->
    <el-dialog
      class="btn-2b5a95"
      title="会计审批："
      :visible.sync="showApprovalModal"
			:close-on-click-modal='false'
			v-if="showApprovalModal"
      append-to-body
			v-dialogDrag
      width="35%"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic form-item-w-100"
        status-icon
        
      >
        <el-form-item
          label="审核是否通过："
          prop="passflag"
          :rules="[
            {
              required: true,
              message: '必填字段',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="dynamicValidateForm.passflag"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in [
                { value: 1, label: '通过' },
                { value: 0, label: '不通过' },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="审批意见："
          prop="approvedesc"
          :rules="[
            {
              required: true,
              message: '必填字段',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            type="textarea"
            v-model.trim="dynamicValidateForm.approvedesc"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="onApprovalClick('dynamicValidateForm')"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <Export
      :exportTitle="'现金初始配置'"
      :transferDialog="transferDialog"
      :exportUrl="exportUrl"
      :exportexcelUrl="exportexcelUrl"
      :exportsaveUrl="exportsaveUrl"
      :searchForm="searchForm"
      @onCloseExport="onCloseExport"
    ></Export>

    <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
			:close-on-click-modal='false'
      width="60%"
      :visible.sync="showDetailModal"
      v-if="showDetailModal"
      append-to-body
			v-dialogDrag
			title="详情"
    >
      <table border="1" cellpadding="10" cellspacing="0" class="base_table">
        <tr>
          <td v-if="dynamicValidateForm.bankorcash == 0">现金/银行：银行</td>
					<td v-if="dynamicValidateForm.bankorcash == 1">现金/银行：现金</td>
          <td>开户名称：{{ dynamicValidateForm.accountname }}</td>
          <td v-if="dynamicValidateForm.isposflag == 0">是否总部POS机：否</td>
					<td v-if="dynamicValidateForm.isposflag == 1">是否总部POS机：是</td>
        </tr>
        <tr>
          <td>初始金额：{{ dynamicValidateForm.initmoney }}</td>
          <td>当前金额：{{ dynamicValidateForm.curmoney }}</td>
          <td>银行卡号：{{ dynamicValidateForm.cardno }}</td>
        </tr>
        <tr>
          <td>存折账号：{{ dynamicValidateForm.bookno }}</td>
          <td v-if="dynamicValidateForm.initedflag == 0">是否已初始化：是</td>
					<td v-if="dynamicValidateForm.initedflag == 1">是否已初始化：否</td>
          <td v-if="dynamicValidateForm.kuaijiapproveflag == -2">会计审核标志：未提请审批</td>
					<td v-if="dynamicValidateForm.kuaijiapproveflag == -1">会计审核标志：审核中</td>
					<td v-if="dynamicValidateForm.kuaijiapproveflag == 0 ">会计审核标志：未通过</td>
					<td v-if="dynamicValidateForm.kuaijiapproveflag == 1">会计审核标志：通过</td>
        </tr>
        <tr>
          <td>会计审核时间：{{ dynamicValidateForm.kuaijiapprovetime | formatDate("YYYY-MM-DD HH:mm:ss") }}</td>
          <td v-if="dynamicValidateForm.ceoapproveflag == -2">总裁审核标志：未提请审批</td>
					<td v-if="dynamicValidateForm.ceoapproveflag == -1">总裁审核标志：审核中</td>
					<td v-if="dynamicValidateForm.ceoapproveflag == 0">总裁审核标志：未通过</td>
					<td v-if="dynamicValidateForm.ceoapproveflag == 1">总裁审核标志：通过</td>
          <td>总裁审核时间：{{ dynamicValidateForm.ceoapprovetime | formatDate("YYYY-MM-DD HH:mm:ss") }}</td>
        </tr>
       <tr>
          <td>会计审核意见：{{ dynamicValidateForm.kuaijiapprovedesc }}</td>
          <td>总裁审核意见：{{ dynamicValidateForm.ceoapprovedesc }}</td>
          <td v-if="dynamicValidateForm.approvestate == -2">审核状态：未提请审批</td>
					<td v-if="dynamicValidateForm.approvestate == -1">审核状态：审核中</td>
					<td v-if="dynamicValidateForm.approvestate == 0">审核状态：未通过</td>
					<td v-if="dynamicValidateForm.approvestate == 1">审核状态：通过</td>
        </tr>
        <tr>
          <td>所属教学点名称：{{ dynamicValidateForm.schoolorgname }}</td>
          <td>所属教学点序号：{{ dynamicValidateForm.schoolorgcode }}</td>
          <td>所属分公司名称：{{ dynamicValidateForm.companyorgname }}</td>
        </tr>
        <tr>
          <td>所属分公司序号：{{ dynamicValidateForm.companyorgcode }}</td>
          <td>审核会计名称：{{ dynamicValidateForm.kuaijiname }}</td>
          <td>审核CEO姓名：{{ dynamicValidateForm.ceoname }}</td>
        </tr>
        <tr>
          <td>银行名称：{{ dynamicValidateForm.bankname }}</td>
          <td v-if="dynamicValidateForm.status == 0">账户是否可用状态：否</td>
					<td v-if="dynamicValidateForm.status == 1">账户是否可用状态：是</td>
					<td>流水号： {{dynamicValidateForm.id}}</td>
        </tr>
       
      </table>
    </el-dialog>
  </div>
</template>


<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
import Export from "@/components/Export/index.vue";
import {
  approve_list,
  account_listcash,
  account_inputcash,
  account_savecash,
  account_delete,
  account_requestapprove,
  account_approvecheck,
  account_approvesave,
  account_export,
  account_exportexcel,
  account_exportsave,
} from "@/request/api/allChildrenProject";
import { _org_combox, _allSchool } from "@/request/api/public";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";
export default {
  mixins: [part],
  name: "account1",
  components: { Export },
  props: {
    exportUrl: {
      default: () => account_export,
    },
    exportexcelUrl: {
      default: () => account_exportexcel,
    },
    exportsaveUrl: {
      default: () => account_exportsave,
    },
  },
  data() {
    //数值表单规则
    var checkfield = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("必填字段"));
      } else {
        if (isNaN(Number(value))) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }
    };
    return {
      passflag: {
        1: "通过",
        0: "不通过",
        2: "",
      },
      // 审批状态
      approvestateVal: {
        1: "通过",
        "-2": "提请审核",
        "-1": "审核中",
        0: "审核不通过",
      },
      searchForm: {id:null},
      transferDialog: false, //导出框
      itemId: null, //首表格项id
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, //显示表单框
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {
        schoolorgname: null,
        schoolorgid: null,
        companyorgname: null,
        companyorgid: null,
      }, //表单
      rules: {
        companyorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        schoolorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        accountname: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则

      showApprovalModal: false, //审批框

      showTable: {}, //查看审批 data
      showModal: false, //查看审批框
      showDetailModal: false,

    };
  },
  created() {
    this.searchForm.id = this.$route.params.id;
    this.getDataList();
    this.org_combox();
    this.org_comboxchild(this.dynamicValidateForm.companyorgid);
		window.addEventListener("keyup", this.enterSelect);
  },
  methods: {
    ...mapActions("global", ["onExtendClick", "isExpand"]),
    ...mapActions("selectData", ["org_combox", "org_comboxchild"]),

    //改变分公司 change
    onChangeCompany(val, form) {
      this[form].schoolorgname = "";
      this[form].companyorgid = val;
      this.org_comboxchild(val);
    },
    onChangeSchool(val, form) {
      this[form].schoolorgid = val;
    },
    //关闭导出框
    onCloseExport(bool) {
      this.transferDialog = false;
    },
		enterSelect(e) {
			if(e.keyCode === 13) {
				this.getDataList();
			}
		},
		visibleType(e) {
			if(!e) {
				this.$refs.selectref.blur();
			}
		},
		reset() {
			this.searchForm = {
				id: null,
				accountname: null,
				approvestate: null,
				schoolorgname: null,
			}
		},
		resetQuery() {
			this.reset();
			this.getDataList();
		},
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: account_listcash,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    // 查看详情 click
    btnShowDetail(row) {
      this.dynamicValidateForm = JSON.parse(JSON.stringify(row));
      this.showDetailModal = true;
    },
    //添加click
    btnAdd() {
			this.dialogTitle = "添加";
      this.dynamicValidateForm = {
        schoolorgid: this.$store.state.login.userinfo.schoolorgid,
        companyorgid: this.$store.state.login.userinfo.companyorgid,
        
      };
      this.$set(this.dynamicValidateForm,'companyorgname',this.$store.state.login.userinfo.companyorgname)
      this.$set(this.dynamicValidateForm,'schoolorgname',this.$store.state.login.userinfo.schoolorgname)
      this.org_comboxchild(this.dynamicValidateForm.companyorgid);
      this.showAddModal = true;
    },
    //修改click
    btnEdit() {
			this.dialogTitle = "修改";
      selectCheck(this.multipleSelection, "修改", false, () => {
        this.editRoutePage(this.multipleSelection[0].id);
      });
    },
    //删除click
    btnDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delTableItem(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //提请审批 click
    btnRequestApprove() {
      selectCheck(this.multipleSelection, "提请审批", true, () => {
        confirmCallBack({
          title: "提示",
          content: "选中的条目将提请审批！",
          success: () => {
            this.reqApproval(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //会计审批 click
    btnVeryfy1() {
      selectCheck(this.multipleSelection, "会计审批", false, () => {
        this.headApproval();
      });
    },
    //查看审批情况 click
    btnViewApprove() {
      selectCheck(this.multipleSelection, "查看审批", false, () => {
        this.approvelist();
      });
    },
    //导出 click
    btnExport() {
      this.transferDialog = true;
    },

    //刷新 click
    btnReload() {
      this.getDataList();
    },
    //修改路由页 api
    editRoutePage(id) {
      myRequest({
        url: account_inputcash,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showAddModal = true;
          this.dynamicValidateForm = res.data.data.taccount;
          this.org_comboxchild(this.dynamicValidateForm.companyorgid);
          delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
          delete this.dynamicValidateForm.isoktime; //isoktime 该字段不用传
          delete this.dynamicValidateForm.kuaijiapprovetime; //kuaijiapprovetime 该字段不用传
        }
      });
    },
    //提交-（添加，修改） api
    submitAddOrEditForm(dynamicValidateForm) {
      this.$refs[dynamicValidateForm].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: account_savecash,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,
              
              modal: "showAddModal",
            }
          );
        }
      });
    },
    //删除 api
    delTableItem(idArr) {
      myRequest(
        {
          method: "post",
          url: account_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //提请审批 api
    reqApproval(ids) {
      myRequest(
        {
          method: "post",
          url: account_requestapprove,
          data: this.$qs.stringify(
            {
              ids: ids,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //审批检查 api
    headApproval() {
      myRequest(
        {
          method: "post",
          url: account_approvecheck,
          data: this.$qs.stringify(
            {
              ids: this.multipleSelection.map((i) => i.id),
              leadertype: "05",
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          
          that: this,
          showModal: "showApprovalModal",
        }
      );
    },
    //审批保存  api
    onApprovalClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.approvesave();
        }
      });
    },
    //查看审批 api
    approvelist() {
      myRequest({
        url: approve_list,
        data: {
          objectname: "T_ACCOUNT",
          objectid: this.multipleSelection[0].id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showTable = res.data.data;
          this.showModal = true;
        }
      });
    },
    //审批保存  api
    approvesave() {
      myRequest(
        {
          method: "post",
          url: account_approvesave,
          data: this.$qs.stringify(
            {
              ids: this.multipleSelection.map((i) => i.id),
              leadertype: "05",
              passflag: this.dynamicValidateForm.passflag,
              approvedesc: this.dynamicValidateForm.approvedesc,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          
          modal: "showApprovalModal",
          isRefTableList: true,
          that: this,
        }
      );
    },

    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style  lang="scss">
	.base_table{
		margin: auto;
	}
</style>